import { get, getRawValue } from '../../../utils/get';
export var getOnlineConfAvailable = function getOnlineConfAvailable(item) {
  if (item === void 0) {
    item = {};
  }

  return item.event && !!getRawValue(item, 'event.onlineConferencing.config.enabled') && !!get(item, 'event.onlineConferencing.session.config.guestLink');
};